<template>
  <div class="sms-list">
    <infinite-loading :identifier="infiniteId" direction="top" @infinite="infiniteHandler"></infinite-loading> 
          
      <div 
        v-for="(message, k) in messages"
        :key="k">
        <div v-if="!message.is_received"
            class="curent-user-messege">
            <div class="messege-container">
            <div class="messege">
                {{message.text}}
            </div>
            <p class="data">{{message_date(message.created_on)}} · {{user_info.recipient_number}}</p>
            </div>
        </div>
        <div v-else
            class="user-messege">
            <img src="../../../assets/ben-unsplash.jpg"
                alt=""
                class="avatar">
            <div class="messege-container">
            <div class="messege">
                {{message.text}}
            </div>
            <p class="data">{{ message_date(message.created_on) }} · {{user_info.recipient_number}}</p>
            </div>
        </div>
      </div>
  </div>
</template>

<script>
import { format } from 'date-fns';
import { mapActions, mapGetters } from 'vuex';

export default {
  components: {
    InfiniteLoading: () => import('vue-infinite-loading'),
  },
  props: ['user_info', 'infiniteId', 'page'],
  data: () => ({
    messages: [],
  }),
  computed: {
    ...mapGetters({
      sms: 'smses/getSmsList',
      //user_info: 'smses/getActiveRecipient',
    }),
    // messages() {
    //   if(this.page === 0) { this.messages = [] }

    //   return [...this.messages, ...this.sms.reverse()]
    // }
  },
  created:async function() {
    // await this.viewSmses({ recipient_uuid: this.user_info.recipient_uuid, page: 0 });
    // this.page += 1;
    // this.messages.unshift(...this.sms.reverse());
    // console.log("messages", this.messages)
  },
  methods: {
    ...mapActions({
      viewSmses: 'smses/getSmsList',
    }),
    message_date(date) {
      return format(date, 'MMM HH:mm')
    },
    infiniteHandler:async  function($state) {
      await this.viewSmses({ recipient_uuid: this.user_info.recipient_uuid, page: this.page });
      if(this.page === 0) { this.messages = [] }
      console.log("this.sms.length", this.sms.length)
      if (this.sms.length) {    
        this.$emit('addpage',this.page + 1);

        //this.page += 1;
        this.messages.unshift(...this.sms.reverse());

        //this.messages = [...this.messages, ...this.sms.reverse()]

        //this.makeSmsRead(this.chat.messages[this.chat.messages.length-1].sms_uuid)

        $state.loaded();
      } else {
        $state.complete();
      }
    },
  },
}
</script>

<style lang="scss" scoped>
  .sms-list {
    .user-messege {
        display: flex;
        width: 100%;
        margin-bottom: 15px;
        .messege-container {
        .messege {
            height: fit-content;
            width: fit-content;
            padding: 5px 15px 5px 15px;
            max-width: 493.38px;
            border-radius: 15px;
            background-color: #f8f9fe;
            color: #55616e;
            font-family: "Helvetica Neue";
            font-size: 14px;
            line-height: 25px;
        }
        .data {
            color: #55616e;
            font-family: "Helvetica Neue";
            font-size: 10px;
            line-height: 12px;
            margin: 5px 0px 0px 15px;
        }
        }
    }
    .curent-user-messege {
        display: flex;
        width: 100%;
        margin-bottom: 15px;
        justify-content: flex-end;
        .messege-container {
        .messege {
            height: fit-content;
            width: fit-content;
            padding: 5px 15px 5px 15px;
            max-width: 493.38px;
            border-radius: 15px;
            background-color: #f8f9fe;
            color: #55616e;
            font-family: "Helvetica Neue";
            font-size: 14px;
            line-height: 25px;
        }
        .data {
            color: #55616e;
            font-family: "Helvetica Neue";
            font-size: 10px;
            line-height: 12px;
            margin: 5px 0px 0px 15px;
        }
        }
    }
  }
</style>